import React, { Component } from 'react';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import { Button, Text } from '@adsk/bim360-matrix-react-components';

/**
 * @TryAgainErrorNotification
 */
class TryAgainErrorNotification extends Component {

  /**
   * render
   */
  render() {
    const { message, tryAgainAction } = this.props;

    return (
      <div className="TryAgainErrorNotification">
        <Text hasHTML>{message}</Text>
        <Button className="TryAgainErrorNotification__link" styleType={Button.StyleType.INLINE_LINK} onClick={() => tryAgainAction()}>
          {T.translate('notifications.tryAgain')}
        </Button>
      </div>
    );
  }
}

TryAgainErrorNotification.displayName = 'TryAgainErrorNotification';

TryAgainErrorNotification.propTypes = {
  message: PropTypes.node.isRequired,
  tryAgainAction: PropTypes.func.isRequired,
};

export default TryAgainErrorNotification;
